import { Map } from "immutable";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { InjectedFormProps } from "redux-form";
import { Field, reduxForm } from "redux-form/immutable";
import UpCustomerSettingsButtonFooter from "../../../../../components/UpCustomerSettingsButtonFooter";
import { selectBox } from "../../../../CustomerSettings/EmailSignature/input-fields";
import { IntegrationInfoList, IntegrationType } from "../../types";
import { RapidmailListsSettings } from "./types";

type RapidmailSettingsFormComponentProps = {
  saving: boolean;
  handleSave: (values: RapidmailListsSettings) => void;
  listOptions: IntegrationInfoList[];
};

const RapidmailSettingsFormComponent = (
  props: RapidmailSettingsFormComponentProps &
    InjectedFormProps<Map<unknown, unknown>, RapidmailSettingsFormComponentProps>
) => {
  const { pristine, invalid, handleSave, handleSubmit, reset, listOptions, saving } = props;

  const intl = useIntl();

  const options = useMemo(
    () => listOptions.map((l) => ({ label: l.name, value: l.id })),
    [listOptions]
  );

  return (
    <div>
      <Field
        name="list"
        component={selectBox}
        type="text"
        label="List to add new optins"
        placeholder="Select List"
        infoText={intl.formatMessage(
          {
            id: `containers.Integrations.list.infoText`,
            defaultMessage:
              "After successfully connected to {integration} new optins will be added to this list. After the creation of a new list in the connected {integration} Account, please, delete this configuration line and re-connect again."
          },
          {
            integration: IntegrationType.RAPIDMAIL
          }
        )}
        width="100%"
        options={options}
      />

      <UpCustomerSettingsButtonFooter
        saveButtonDisabled={pristine || invalid}
        resetButtonDisabled={pristine}
        saveButtonOnClick={handleSubmit((values) => handleSave(values.toJS()))}
        resetButtonOnClick={reset}
        saving={saving}
      />
    </div>
  );
};

export const RapidmailSettingsForm = reduxForm<
  Map<unknown, unknown>,
  RapidmailSettingsFormComponentProps
>({
  form: `IntegrationForm_rapidmail`,
  enableReinitialize: true
})(RapidmailSettingsFormComponent);
